<div class="d-flex justify-content-center align-items-center" style="height:100vh;">
    <div class="text-center fade-in">
        <div class="alert alert-danger" role="alert">
            <h1><i class="fas fa-tools"></i> Estamos en mantenimiento</h1>
            <h2>Vuelva más tarde, gracias por su comprensión.</h2>
        </div>
    </div>
</div>